import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import useAvailableForms from 'src/components/FormSubmissions/useAvailableForms';
import FilterBar from 'src/components/Dashboard/components/FilterBar';
import DropdownMenu from 'src/common/Menu/DropdownMenu';
import { env } from 'src/config/env';
import { getContactFromState } from 'src/components/Contacts/utils';
// import useFormSubmissions from 'src/components/FormSubmissions/useFormSubmissions';
import { browserHistory } from 'src/common/utils/browserHistory';
import { Button, Icon } from '@unite-us/ui';
import { useToast, ComponentLibraryLoader } from '@unite-us/app-components';
import { datadogRum } from '@datadog/browser-rum';
import { getAuthToken } from 'src/api/config';
import * as apiHooks from 'src/api/APIHooks';
import _ from 'lodash';
import './FacesheetScreenings.scss';

const FacesheetAssessments = ComponentLibraryLoader({
  loadFn: () => import('@unite-us/app-screenings'),
  component: 'FacesheetScreenings',
  source: 'app-screenings',
  loadingApp: 'web-app',
  datadogRum,
});

function renderDefaultFilterBar(filter, isFetching, paging, onNextClick, onPrevClick) {
  return (
    <FilterBar
      filters={filter}
      onFiltersChange={() => {}}
      paging={paging}
      onNextClick={onNextClick}
      onPrevClick={onPrevClick}
      isFetching={isFetching}
      topMargin={false}
    />
  );
}

function renderHistoryFilterBar(_filter, isFetching, paging, onNextClick, onPrevClick) {
  return renderDefaultFilterBar([], isFetching, paging, onNextClick, onPrevClick);
}

function createAddScreeningDropdown(onSelectNewForm) {
  return (formsForSubmissions) => (
    <DropdownMenu
      options={formsForSubmissions}
      onChange={(item) => onSelectNewForm(item.value)}
      placeholder={(
        <Button
          id="new-screening-submission"
          label="Add New Screening"
          labelposition="after"
          iconLeft={<Icon icon="IconPlusCircle" className="fill-current" />}
          primary
        />
      )}
    />
  );
}

function renderEmptyDropdownMenu() {
  return null;
}

function getScreeningsControls({
  historyMode,
  onSelectNewForm,
}) {
  if (historyMode) {
    return {
      filterBar: renderHistoryFilterBar,
      dropdownMenu: renderEmptyDropdownMenu,
    };
  }

  return {
    filterBar: renderDefaultFilterBar,
    dropdownMenu: createAddScreeningDropdown(onSelectNewForm),
  };
}

export function FacesheetScreenings({
  contact,
  employee,
  provider,
  children,
  historyMode,
}) {
  // const size = 50;
  // const context = contact.id;
  // const contextType = 'person';
  // const consolidate = true;
  // const [formFilter, setFormFilter] = useState('');
  // const [page, setPage] = useState(1);

  const handleViewFormSubmission = (formSubmission) => {
    browserHistory.push(`/screenings/v2/facesheet/${contact.id}/submission/${formSubmission.id}`);
  };

  const handleSelectNewForm = (formId) => {
    browserHistory.push(
      `/facesheet/${contact.id}/screenings/${formId}/submissions/new`,
    );
  };
  const { addToast } = useToast();
  const screeningsControls = getScreeningsControls({
    historyMode,
    onSelectNewForm: handleSelectNewForm,
  });

  if (children) {
    return children;
  }

  const formFilter = '';

  return (
    <div className={historyMode ? 'facesheet-screenings-history-mode' : ''}>
      <FacesheetAssessments
        source="web_app"
        hooks={{ apiHooks }}
        callbacks={{
          notify: {
            error: (message) => addToast({ message, type: 'error' }),
            success: (message) => addToast({ message, type: 'success' }),
            warn: (message) => addToast({ message, type: 'warning' }),
          },
          goBack: () => {
            browserHistory.goBack();
          },
          replace: (path) => {
            browserHistory.replace(path);
          },
          pushInHistory: (url) => {
            browserHistory.push(url);
          },
        }}
        // formSubmissions={formSubmissions}
        handleViewFormSubmission={handleViewFormSubmission}
        hasFilters={formFilter !== ''}
        contact={contact}
        filterBar={screeningsControls.filterBar}
        dropdownMenu={screeningsControls.dropdownMenu}
        appSettings={{
          env: {
            getAuthToken,
            employee,
            employeeId: employee?.id,
            providerId: provider?.id,
            provider,
            coreUrl: env.CORE_API,
            screeningsApiUrl: `${env.SCREENING_BASE_URL}/v2`,
          },
        }}
      />
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  const contactId = _.wget(ownProps, 'params.id', '');
  const contact = getContactFromState(state, contactId);
  const currentProvider = state.globalState.currentProvider.group;
  const currentEmployee = state.globalState.currentEmployee;
  return {
    contact,
    provider: currentProvider,
    employee: currentEmployee,
  };
}

FacesheetScreenings.propTypes = {
  contact: PropTypes.object.isRequired,
  provider: PropTypes.object.isRequired,
  employee: PropTypes.object.isRequired,
  children: PropTypes.node,
  historyMode: PropTypes.bool,
};

FacesheetScreenings.defaultProps = {
  children: null,
  historyMode: false,
};

export default connect(mapStateToProps)(FacesheetScreenings);
